//
// import {Component, OnInit, ViewChild} from '@angular/core';
// import {MatTableDataSource} from "@angular/material/table";
// import {EducationMom} from "../education-mom.model";
// import {MatPaginator} from "@angular/material/paginator";
// import {MatSort} from "@angular/material/sort";
// import {LogService} from "../../../../../services/log.service";
// import {Router} from "@angular/router";
// import {PermissionType} from "../../../../../components/employee/PermissionType.enum";
// import {EducationMomService} from "../education-mom.service";
// import {MatDialog} from "@angular/material/dialog";
// import {AddEditEducationMomComponent} from "../add-edit-education-mom/add-edit-education-mom.component";
// import {DomSanitizer, SafeHtml} from "@angular/platform-browser";
//
// @Component({
//   selector: 'app-education-mom-list',
//   templateUrl: './education-mom-list.component.html',
//   styleUrls: ['./education-mom-list.component.scss']
// })
// export class EducationMomListComponent implements OnInit {
//
//   displayedColumns: string[] = [
//     'srNo',
//     'date',
//     'centreName',
//     'place',
//     'type',
//     'suggestions',
//     'actions'
//   ];
//
//   dataSource = new MatTableDataSource<EducationMom>([]);
//
//   @ViewChild(MatPaginator) paginator!: MatPaginator;
//   @ViewChild(MatSort) sort!: MatSort;
//
//   constructor(
//     private educationService: EducationMomService,
//     private mLogService: LogService,
//     private dialog: MatDialog,
//     private readonly matDialog: MatDialog,
//     private router: Router,
//     private sanitizer: DomSanitizer
//   ) {}
//
//   ngOnInit(): void {
//     this.loadList();
//   }
//
//   loadList() {
//     this.educationService.getAll().subscribe((data: any) => {
//       this.dataSource.data = data;
//       console.log(data);
//       this.dataSource.paginator = this.paginator;
//       this.dataSource.sort = this.sort;
//     });
//   }
//
//   applyFilter(event: KeyboardEvent) {
//     const input = event.target as HTMLInputElement;
//     this.dataSource.filter = input.value.trim().toLowerCase();
//   }
//
//   toggleReadMore(row: any) {
//     row._expanded = !row._expanded;
//   }
//
//   addMom() {
//     this.dialog.open(AddEditEducationMomComponent, {
//       width: '900px',
//       maxHeight: '80vh',
//       disableClose: true,
//       autoFocus: false,
//       data: null
//     });
//   }
//
//   edit(row: EducationMom) {
//     this.matDialog.open(AddEditEducationMomComponent, {
//       data: row,
//       width: '900px',
//       autoFocus: false
//     });
//   }
// // image not coming
//   view(row: any) {
//     const activity = {
//       date: new Date().getTime(),
//       section: 'Education Meeting',
//       action: 'Viewed',
//       description: `Education Meeting viewed by user`,
//       currentIp: localStorage.getItem('currentip')!
//     };
//     this.mLogService.addLog(activity);
//     this.router.navigate(['/home/education/education-mom-view', row.id]);
//   }
//
//   delete(id: string | undefined) {
//     if (!id) return;
//
//     if (confirm('Are you sure to delete this Meeting?')) {
//       this.educationService.deleteRow(id)
//         .then(() => {
//           alert('Meeting deleted successfully');
//           const activity = {
//             date: new Date().getTime(),
//             section: 'Education Meeting',
//             action: 'Deleted',
//             description: `Education Meeting deleted by user`,
//             currentIp: localStorage.getItem('currentip')!
//           };
//           this.mLogService.addLog(activity);
//         })
//         .catch((error) => {
//           console.error('Error deleting Meeting:', error);
//           alert('Error deleting Meeting!');
//         });
//     }
//   }
//
//   // Check if content has images or media
//   hasMediaContent(htmlContent: string): boolean {
//     if (!htmlContent) return false;
//
//     const tempDiv = document.createElement('div');
//     tempDiv.innerHTML = htmlContent;
//
//     // Check for images
//     const hasImages = tempDiv.querySelectorAll('img').length > 0;
//
//     // Check for YouTube embeds
//     const hasYoutube = htmlContent.includes('<oembed url=') ||
//       htmlContent.includes('youtube.com') ||
//       htmlContent.includes('youtu.be');
//
//     // Check for other embeds
//     const hasEmbeds = tempDiv.querySelectorAll('iframe, video, audio, embed').length > 0;
//
//     return hasImages || hasYoutube || hasEmbeds;
//   }
//
//   //  Process content to show small images
//   processContentForList(htmlContent: string, isExpanded: boolean): SafeHtml {
//     if (!htmlContent) return '';
//
//     let processed = htmlContent;
//
//     // Process YouTube embeds
//     processed = this.sanitizeYoutube(processed);
//
//     const tempDiv = document.createElement('div');
//     tempDiv.innerHTML = processed;
//
//     // Make images smaller
//     const images = tempDiv.querySelectorAll('img');
//     images.forEach(img => {
//       img.style.maxWidth = '120px';
//       img.style.maxHeight = '80px';
//       img.style.objectFit = 'cover';
//       img.style.borderRadius = '4px';
//       img.style.margin = '4px';
//       img.style.cursor = 'pointer';
//       img.style.border = '1px solid #ddd';
//     });
//
//     // Make iframes smaller
//     const iframes = tempDiv.querySelectorAll('iframe');
//     iframes.forEach(iframe => {
//       iframe.style.maxWidth = '200px';
//       iframe.style.maxHeight = '120px';
//     });
//
//     // If not expanded and has text, truncate
//     if (!isExpanded && !this.hasMediaContent(htmlContent)) {
//       const textContent = this.stripHtml(tempDiv.innerHTML);
//       if (textContent.length > 60) {
//         return this.sanitizer.bypassSecurityTrustHtml(textContent.substring(0, 60));
//       }
//     }
//
//     return this.sanitizer.bypassSecurityTrustHtml(tempDiv.innerHTML);
//   }
//
//   //  Get display content based on media presence
//   getDisplayContent(row: any): SafeHtml {
//     if (!row.suggestions || row.suggestions.trim() === '') {
//       return '-';
//     }
//
//     const hasMedia = this.hasMediaContent(row.suggestions);
//
//     // If has media, always show full content with small images (no truncation)
//     if (hasMedia) {
//       return this.processContentForList(row.suggestions, true);
//     }
//
//     // If no media, handle text truncation with read more/less
//     if (row._expanded) {
//       return this.sanitizer.bypassSecurityTrustHtml(row.suggestions);
//     } else {
//       const plainText = this.stripHtml(row.suggestions);
//       if (plainText.length <= 60) {
//         return this.sanitizer.bypassSecurityTrustHtml(row.suggestions);
//       } else {
//         return plainText.substring(0, 60);
//       }
//     }
//   }
//
//   //  Check if should show read more button
//   shouldShowReadMore(row: any): boolean {
//     if (!row.suggestions) return false;
//
//     // Don't show read more if content has media
//     if (this.hasMediaContent(row.suggestions)) return false;
//
//     // Show read more only for long text content
//     const plainText = this.stripHtml(row.suggestions);
//     return plainText.length > 60;
//   }
//
//   sanitizeYoutube(content: string): string {
//     if (!content) return '';
//
//     return content.replace(
//       /<figure class="media"><oembed url="([^"]+)"><\/oembed><\/figure>/g,
//       (match, url) => {
//         let videoId = '';
//
//         if (url.includes('youtu.be/')) {
//           videoId = url.split('youtu.be/')[1].split(/[?&]/)[0];
//         } else if (url.includes('watch?v=')) {
//           videoId = url.split('watch?v=')[1].split(/[?&]/)[0];
//         }
//
//         if (!videoId) return match;
//
//         return `
//         <iframe width="200" height="120"
//           src="https://www.youtube.com/embed/${videoId}"
//           frameborder="0" allowfullscreen>
//         </iframe>
//       `;
//       }
//     );
//   }
//
//   extractYoutubeUrl(html: string): string {
//     if (!html) return '';
//     const match = html.match(/<oembed url="([^"]+)"/);
//     return match ? match[1] : '';
//   }
//
//   stripHtml(html: string): string {
//     const div = document.createElement('div');
//     div.innerHTML = html;
//     return div.textContent || div.innerText || '';
//   }
//
//   protected readonly PermissionType = PermissionType;
// }


import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {MatTableDataSource} from "@angular/material/table";
import {EducationMom} from "../education-mom.model";
import {MatPaginator} from "@angular/material/paginator";
import {MatSort} from "@angular/material/sort";
import {LogService} from "../../../../../services/log.service";
import {Router} from "@angular/router";
import {PermissionType} from "../../../../../components/employee/PermissionType.enum";
import {EducationMomService} from "../education-mom.service";
import {MatDialog} from "@angular/material/dialog";
import {AddEditEducationMomComponent} from "../add-edit-education-mom/add-edit-education-mom.component";
import {DomSanitizer, SafeHtml} from "@angular/platform-browser";
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import {FormControl} from "@angular/forms";
import {Observable, Subject} from "rxjs";
import {takeUntil} from "rxjs/operators";
import {CentreOption, EducationObservation} from "../../educationObservation/education-observation.model";
import {MatSelectChange} from "@angular/material/select";
import {CentreService} from "../../../../../services/centre.service";
import {FinancialYearService} from "../../../../../services/financial-year.service";

@Component({
  selector: 'app-education-mom-list',
  templateUrl: './education-mom-list.component.html',
  styleUrls: ['./education-mom-list.component.scss']
})
export class EducationMomListComponent implements OnInit, OnDestroy {
  private _destroyed$ = new Subject<void>();

  displayedColumns: string[] = [
    'srNo',
    'date',
    'centreName',
    'place',
    'type',
    'suggestions',
    'actions'
  ];

  SelectCentre = new FormControl('')
  centres$!: Observable<CentreOption[]>;
  selectedCentre: string | null = null;
  startDate = new FormControl<Date | null>(null);
  endDate = new FormControl<Date | null>(null);
  isLoading = false;

  dataSource = new MatTableDataSource<EducationMom>([]);
  allMom: EducationMom[] = [];

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  constructor(
    private educationService: EducationMomService,
    private mLogService: LogService,
    private dialog: MatDialog,
    private readonly matDialog: MatDialog,
    private router: Router,
    private sanitizer: DomSanitizer,
    private readonly centreService: CentreService,
    private readonly financialYearService: FinancialYearService,
  ) {
    this.centres$ = centreService.getAllCentres()
  }

  ngOnInit(): void {
    const fy = this.financialYearService.getCurrentFinancialYear();
    this.startDate.setValue(fy.startDate);
    this.endDate.setValue(fy.endDate);
    this.loadList();
  }

  loadList() {
    this.educationService.getAll().pipe(takeUntil(this._destroyed$)).subscribe((data: any) => {
      this.dataSource.data = data;
      this.allMom = data;
      console.log('Loaded data:', data);
      if (data.length > 0) {
        console.log('First item suggestions:', data[0].suggestions);
      }
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    });
  }

  applyFilter(event: KeyboardEvent) {
    const input = event.target as HTMLInputElement;
    this.dataSource.filter = input.value.trim().toLowerCase();
  }

  toggleReadMore(row: any) {
    row._expanded = !row._expanded;
  }

  addMom() {
    this.dialog.open(AddEditEducationMomComponent, {
      width: '900px',
      maxHeight: '80vh',
      disableClose: true,
      autoFocus: false,
      data: null
    }).afterClosed().subscribe(() => {
      this.loadList(); //  Reload after dialog closes
    });
  }

  edit(row: EducationMom) {
    this.matDialog.open(AddEditEducationMomComponent, {
      data: row,
      width: '900px',
      autoFocus: false
    }).afterClosed().subscribe(() => {
      this.loadList(); //Reload after dialog closes
    });
  }

  view(row: any) {
    const activity = {
      date: new Date().getTime(),
      section: 'Education Meeting',
      action: 'Viewed',
      description: `Education Meeting viewed by user`,
      currentIp: localStorage.getItem('currentip')!
    };
    this.mLogService.addLog(activity);
    this.router.navigate(['/home/education/education-mom-view', row.id]);
  }

  delete(id: string | undefined) {
    if (!id) return;

    if (confirm('Are you sure to delete this Meeting?')) {
      this.educationService.deleteRow(id)
        .then(() => {
          alert('Meeting deleted successfully');
          const activity = {
            date: new Date().getTime(),
            section: 'Education Meeting',
            action: 'Deleted',
            description: `Education Meeting deleted by user`,
            currentIp: localStorage.getItem('currentip')!
          };
          this.mLogService.addLog(activity);
          this.loadList(); // Reload after delete
        })
        .catch((error) => {
          console.error('Error deleting Meeting:', error);
          alert('Error deleting Meeting!');
        });
    }
  }

  onCentreChange(event: MatSelectChange) {
    this.selectedCentre = event.value;
  }


  search() {
    this.isLoading = true;

    const centre = this.selectedCentre || this.SelectCentre.value || 'All';

    const from = this.startDate.value
      ? new Date(new Date(this.startDate.value).setHours(0, 0, 0, 0))
      : null;

    const to = this.endDate.value
      ? new Date(new Date(this.endDate.value).setHours(23, 59, 59, 999))
      : null;

    let filtered = [...this.allMom];


    if (centre !== 'All') {
      filtered = filtered.filter(item => item.centreCode === centre);
    }

    if (from && to) {
      filtered = filtered.filter(item => {
        const itemDate = item.date?.toDate();
        return itemDate >= from && itemDate <= to;
      });
    }

    this.dataSource = new MatTableDataSource(filtered);
    this.dataSource.sort = this.sort!;
    this.dataSource.paginator = this.paginator!;
    this.paginator?.firstPage();

    this.isLoading = false;
  }

  clearAll() {
    this.selectedCentre = 'All';
    this.SelectCentre.setValue('All');
    const fy = this.financialYearService.getCurrentFinancialYear();
    this.startDate.setValue(fy.startDate);
    this.endDate.setValue(fy.endDate);

    this.dataSource.data = this.allMom;
    this.dataSource.sort = this.sort!;
    this.dataSource.paginator = this.paginator!;
    this.paginator?.firstPage();
  }


  // ENHANCED: Better media detection using multiple methods
  hasMediaContent(htmlContent: string): boolean {
    if (!htmlContent) return false;

    // Method 1: Direct string checks (faster)
    const hasImgTag = /<img[\s\S]*?>/i.test(htmlContent);
    const hasBase64 = /data:image\//i.test(htmlContent);
    const hasSrc = /src=["']http/i.test(htmlContent);
    const hasFirebaseUrl = /firebasestorage\.googleapis\.com/i.test(htmlContent);

    // Method 2: Check for YouTube/media embeds
    const hasYoutube = /<oembed/i.test(htmlContent) ||
      /youtube\.com/i.test(htmlContent) ||
      /youtu\.be/i.test(htmlContent);

    const hasIframe = /<iframe/i.test(htmlContent);
    const hasVideo = /<video/i.test(htmlContent);
    const hasFigure = /<figure/i.test(htmlContent);

    const result = hasImgTag || hasBase64 || hasSrc || hasFirebaseUrl ||
      hasYoutube || hasIframe || hasVideo || hasFigure;

    // Debug log to see what's detected
    if (result) {
      console.log('Media detected:', {
        hasImgTag,
        hasBase64,
        hasSrc,
        hasFirebaseUrl,
        hasYoutube,
        hasIframe,
        hasVideo,
        hasFigure
      });
    }

    return result;
  }

  // ENHANCED: Better content processing
  processContentForList(htmlContent: string, isExpanded: boolean): SafeHtml {
    if (!htmlContent) return '';

    let processed = htmlContent;

    // Process YouTube embeds
    processed = this.sanitizeYoutube(processed);

    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = processed;

    // Process all images with better styling
    const images = tempDiv.querySelectorAll('img');
    console.log('Found images in content:', images.length);

    images.forEach((img, index) => {
      console.log(`Image ${index}:`, img.src?.substring(0, 100)); // Log image URLs

      img.style.maxWidth = '120px';
      img.style.maxHeight = '80px';
      img.style.objectFit = 'cover';
      img.style.borderRadius = '4px';
      img.style.margin = '4px';
      img.style.cursor = 'pointer';
      img.style.border = '1px solid #ddd';
      img.style.display = 'inline-block';
      img.style.verticalAlign = 'middle';
    });

    // Make iframes smaller
    const iframes = tempDiv.querySelectorAll('iframe');
    iframes.forEach(iframe => {
      iframe.style.maxWidth = '200px';
      iframe.style.maxHeight = '120px';
      iframe.style.display = 'inline-block';
      iframe.style.verticalAlign = 'middle';
    });

    // Process figure elements
    const figures = tempDiv.querySelectorAll('figure');
    figures.forEach(figure => {
      figure.style.display = 'inline-block';
      figure.style.margin = '4px';
      figure.style.verticalAlign = 'middle';
    });

    return this.sanitizer.bypassSecurityTrustHtml(tempDiv.innerHTML);
  }

  // Get display content based on media presence
  getDisplayContent(row: any): SafeHtml {
    if (!row.suggestions || row.suggestions.trim() === '') {
      return '-';
    }
    const hasMedia = this.hasMediaContent(row.suggestions);
    // If has media, always show full content with small images (no truncation)
    if (hasMedia) {
      return this.processContentForList(row.suggestions, true);
    }

    // If no media, handle text truncation with read more/less
    if (row._expanded) {
      return this.sanitizer.bypassSecurityTrustHtml(row.suggestions);
    } else {
      const plainText = this.stripHtml(row.suggestions);
      if (plainText.length <= 60) {
        return this.sanitizer.bypassSecurityTrustHtml(row.suggestions);
      } else {
        return plainText.substring(0, 60);
      }
    }
  }

  // Check if should show read more button
  shouldShowReadMore(row: any): boolean {
    if (!row.suggestions) return false;

    // Don't show read more if content has media
    if (this.hasMediaContent(row.suggestions)) return false;

    // Show read more only for long text content
    const plainText = this.stripHtml(row.suggestions);
    return plainText.length > 60;
  }

  sanitizeYoutube(content: string): string {
    if (!content) return '';

    return content.replace(
      /<figure class="media"><oembed url="([^"]+)"><\/oembed><\/figure>/g,
      (match, url) => {
        let videoId = '';

        if (url.includes('youtu.be/')) {
          videoId = url.split('youtu.be/')[1].split(/[?&]/)[0];
        } else if (url.includes('watch?v=')) {
          videoId = url.split('watch?v=')[1].split(/[?&]/)[0];
        }

        if (!videoId) return match;

        return `
        <iframe width="200" height="120"
          src="https://www.youtube.com/embed/${videoId}"
          frameborder="0" allowfullscreen>
        </iframe>
      `;
      }
    );
  }

  extractYoutubeUrl(html: string): string {
    if (!html) return '';
    const match = html.match(/<oembed url="([^"]+)"/);
    return match ? match[1] : '';
  }
  downloadExcel(): void {
    const data = this.dataSource?.filteredData || [];

    if (!data.length) {
      return;
    }

    const exportData = data.map((row: any, index: number) => ({
      'Sr No': index + 1,
      'Date': row.date ? row.date.toDate().toLocaleDateString() : '',
      'Centre': row.centreName || '',
      'Place': row.place || '',
      'Type': row.type || '',
      'Suggestion': this.stripHtml(row.suggestions || '')
    }));

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(exportData);
    const workbook: XLSX.WorkBook = {
      Sheets: { 'Education MOM': worksheet },
      SheetNames: ['Education MOM']
    };

    const excelBuffer: any = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'array'
    });

    this.saveAsExcelFile(excelBuffer, 'Education_MOM_List');
  }
  saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type: 'application/octet-stream'
    });
    FileSaver.saveAs(data, `${fileName}_${new Date().getTime()}.xlsx`);
  }


  stripHtml(html: string): string {
    if (!html) {
      return '';
    }

    const div = document.createElement('div');
    div.innerHTML = html;
    return div.textContent || div.innerText || '';
  }




  ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }

  protected readonly PermissionType = PermissionType;
}
